import { fetchFactory } from 'isotope-client'

/**
 * Récupération du model via son type
 * @param type
 * @returns {*}
 */
export const getDocumentModelByType = (type) => fetchFactory(`/document-model?type=${type}`)
